import { useAddToast } from "./Toasts";

function copy(text:string){
    var textArea = document.createElement('textarea')
    textArea.style.width = '100px';
    textArea.style.height = '100px';
    textArea.style.position = "absolute";
    textArea.style.top = "-200px"

    textArea.value = text

    document.body.appendChild(textArea);

    textArea.setSelectionRange(0, text.length);
    textArea.focus()

    document.execCommand("copy", false, null)

    setTimeout(() => document.body.removeChild(textArea), 1000);

}

export function useCopy(alert = "Copiado!"){
    const addToast = useAddToast()
    return (text:string) =>{
        copy(text);
        addToast(alert)
    };
}